import React from "react";
import {observer} from "mobx-react";
import {PaymentEntity} from "@dropDesk/domain/entities/payment/payment.entity";
import {ColorScheme} from "@dropDesk/domain/entities/theme/color_scheme";
import {formatCurrency} from "@dropDesk/utils/helpers/common";
import InvoiceItem from "./invoice_item";
import {
    PanelContainer,
    PanelHeader,
    PanelTitle,
    PanelSubtitle,
    TableWrapper,
    InvoiceTable,
    TableHead,
    TableBody,
    TableHeaderRow,
    TableHeaderCell,
    Divider,
    FooterRow,
    FooterLabel,
    FooterValue,
} from "./styled";

const InvoiceExpandedContent = observer(({payment, colors}: {
    payment: PaymentEntity;
    colors: ColorScheme;
}) => {
    return (
        <PanelContainer background={colors.onBackground} borderColor={colors.border}>
            <PanelHeader>
                <PanelTitle color={colors.hintInverse}>Composição da cobrança</PanelTitle>
                <PanelSubtitle color={colors.hint}>Itens que compõem o valor total desta cobrança.</PanelSubtitle>
            </PanelHeader>
            <TableWrapper borderColor={colors.border}>
                <InvoiceTable>
                    <TableHead>
                        <TableHeaderRow background={colors.delicateBackground} borderColor={colors.border}>
                            <TableHeaderCell color={colors.hintInverse}>Produto</TableHeaderCell>
                            <TableHeaderCell color={colors.hintInverse}>Descrição</TableHeaderCell>
                            <TableHeaderCell color={colors.hintInverse}>Período</TableHeaderCell>
                            <TableHeaderCell color={colors.hintInverse}>Valor</TableHeaderCell>
                        </TableHeaderRow>
                    </TableHead>
                    <TableBody>
                        {payment.items?.map((item, index) => (
                            <InvoiceItem
                                key={index}
                                item={item}
                                periodFormatted={payment.periodFormatted}
                                colors={colors}
                            />
                        ))}
                    </TableBody>
                </InvoiceTable>
            </TableWrapper>
            <Divider borderColor={colors.border}/>
            <FooterRow>
                <FooterLabel color={colors.hint}>Total da cobrança</FooterLabel>
                <FooterValue color={colors.text}>{formatCurrency(payment.value)}</FooterValue>
            </FooterRow>
        </PanelContainer>
    );
});

export default InvoiceExpandedContent;
